import { IPowerThinkPadVantageShell } from "src/app/data-models/power/power-thinkpad.vantage-shell.interface";
import { PowerMode } from "src/app/enums/power-mode.enum";
import { FlipToBootCurrentModeEnum, FlipToBootErrorCodeEnum, FlipToBootSetStatusEnum, FlipToBootSupportedEnum } from "../../flipToBoot.enum";
import { FlipToBootErrorStatusInterface, FlipToBootInterface } from "../../flipToBoot.interface";
import { PowerSettingsBase } from "../power-settings.base";

export class PowerSettingsThinkpad extends PowerSettingsBase {
	constructor(private powerThinkPadVantageShell: IPowerThinkPadVantageShell) {
		super();
	}

	public async setAlwaysOnUSBStatus(isEnabled: boolean): Promise<boolean> {
		const alwaysOnUSB = await this.powerThinkPadVantageShell.sectionAlwaysOnUsb.getAlwaysOnUsb();
		return this.setAlwaysOnUSBStatusThinkPad(isEnabled, alwaysOnUSB.isChargeFromShutdown);
	}

	public getAlwaysOnUSBCapability(): Promise<boolean> {
		return this.powerThinkPadVantageShell.sectionAlwaysOnUsb.getAlwaysOnUsbCapability();
	}

	public async setUSBCharging(isChargeFromShutdown: boolean): Promise<boolean> {
		const alwaysOnUSB = await this.powerThinkPadVantageShell.sectionAlwaysOnUsb.getAlwaysOnUsb();
		return this.setAlwaysOnUSBStatusThinkPad(alwaysOnUSB.isEnabled, isChargeFromShutdown);
	}

	public getUSBChargingCapability(): Promise<boolean> {
		return Promise.resolve(true);
	}

	public setAirplaneMode(isEnabled: boolean): Promise<boolean> {
		return this.powerThinkPadVantageShell.sectionAirplaneMode.setAirplaneMode(isEnabled);
	}


	public getAirplaneModeCapability(): Promise<boolean> {
		return this.powerThinkPadVantageShell.sectionAirplaneMode.getAirplaneModeCapability();
	}

	public setAirplaneModeAutoDetection(isEnabled: boolean): Promise<boolean> {
		return this.powerThinkPadVantageShell.sectionAirplaneMode.setAirplaneModeAutoDetection(isEnabled);
	}

	public setEasyResume(isEnabled: boolean): Promise<boolean> {
		return this.powerThinkPadVantageShell.sectionEasyResume.setEasyResume(isEnabled);
	}

	public getEasyResumeCapability(): Promise<boolean> {
		return this.powerThinkPadVantageShell.sectionEasyResume.getEasyResumeCapability();
	}

	public setFlipToBoot(status: FlipToBootSetStatusEnum): Promise<FlipToBootErrorStatusInterface> {
		return Promise.resolve(undefined);
	}

	public getFlipToBoot(): Promise<FlipToBootInterface> {
		const flipToBootInterface = {
			Supported: FlipToBootSupportedEnum.Fail,
			ErrorCode: FlipToBootErrorCodeEnum.Succeed,
			CurrentMode: FlipToBootCurrentModeEnum.SucceedDisable
		} as FlipToBootInterface;

		return Promise.resolve(flipToBootInterface);
	}

	private setAlwaysOnUSBStatusThinkPad(isEnabled: boolean, isChargeFromShutdown: boolean): Promise<boolean> {
		let powerMode: PowerMode;
		if (isEnabled && isChargeFromShutdown) {
			powerMode = PowerMode.Shutdown;
		} else if (isEnabled) {
			powerMode = PowerMode.Sleep;
		} else {
			powerMode = PowerMode.Disabled;
		}

		return this.powerThinkPadVantageShell.sectionAlwaysOnUsb.setAlwaysOnUsb(powerMode, isChargeFromShutdown);
	}
}
